// src/services/emailDatasourceService.js
import axios from 'axios';
import { API_CONFIG } from '../config/api';

const API_BASE_URL = API_CONFIG.BASE_URL;

const createAuthenticatedRequest = () => {
  const token = localStorage.getItem('token') || localStorage.getItem('authToken');
  if (!token) {
    throw new Error('No authentication token found. Please login again.');
  }
  return axios.create({
    baseURL: API_BASE_URL,
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
};

const handleApiError = (error, operation) => {
  console.error(`❌ ${operation} failed:`, error);
  if (error.response?.status === 401) throw new Error('Authentication failed. Please login again.');
  if (error.response?.status === 403) throw new Error('Access denied.');
  if (error.response?.data?.detail) {
    const detail = error.response.data.detail;
    const msg = Array.isArray(detail)
      ? detail.map(d => d.msg || JSON.stringify(d)).join(', ')
      : String(detail);
    throw new Error(msg);
  }
  if (error.message) throw new Error(error.message);
  throw new Error(`${operation} failed. Please try again.`);
};

export const emailDatasourceService = {
  create: async (data) => {
    try {
      const api = createAuthenticatedRequest();
      const response = await api.post('/api/email-datasources', data);
      return response.data;
    } catch (error) {
      handleApiError(error, 'Creating Email datasource');
    }
  },

  list: async () => {
    try {
      const api = createAuthenticatedRequest();
      const response = await api.get('/api/email-datasources');
      return response.data;
    } catch (error) {
      handleApiError(error, 'Listing Email datasources');
    }
  },

  delete: async (id) => {
    try {
      const api = createAuthenticatedRequest();
      const response = await api.delete(`/api/email-datasources/${id}`);
      return response.data;
    } catch (error) {
      handleApiError(error, 'Deleting Email datasource');
    }
  },

  update: async (id, data) => {
    try {
      const api = createAuthenticatedRequest();
      const response = await api.put(`/api/email-datasources/${id}`, data);
      return response.data;
    } catch (error) {
      handleApiError(error, 'Updating Email datasource');
    }
  },

  testConnection: async (id) => {
    try {
      const api = createAuthenticatedRequest();
      const response = await api.post(`/api/email-datasources/${id}/test`);
      return response.data;
    } catch (error) {
      handleApiError(error, 'Testing Email datasource');
    }
  }
};

export default emailDatasourceService;
